<template>
    <ul class="navs left">
        <li><a href="/">首页</a></li>
        <li v-for="(items,index) in category" :key="items.id">
            <a href="javascript:;" @click="catesearch(items.title,index)" rel="nofollow">{{items.title}}</a>
        </li>
        <!-- <li><a href="javascript:;" @click="$router.push({path: '/miaosha'})">积分商城</a></li> -->
        <li><a href="javascript:;" @click="$router.push({path: '/article'})">两性百科</a></li>
        <!-- <li><a href="javascript:;" @click="$router.push({path: '/life'})">两性百科</a></li> -->
    </ul>
</template>

<script>
export default{
    data(){
		return{
			//nav
            category:[],
            type: 1,
		}
	},
    mounted() {
        this.getShopCate();
    },
    methods:{
        //获取所有商品分类
        getShopCate() {
            this.$api.getCategory.getShopCate({}).then(res => {
                if (res.code == 200) {
                    this.category = [];
                    var arr = res.result.cate;
                    arr.forEach(item => {
                        if (item.show == 1) {
                            this.category.push(item);
                        }
                    });
                    console.log(this.category);
                    this.type = res.result.types;
                }
            });
        },
        catesearch(title,index){
            if(index == 0){
                this.$router.push(`/man/`);
            }else if(index == 1){
                this.$router.push(`/woman/`);
            }else if(index == 5){
                this.$router.push(`/biyuntao/`);
            }else if(index == 2){
                this.$router.push(`/zhuxing/`);
            }else if(index == 3){
                this.$router.push(`/lingleiwanju/`);
            }else if(index == 4){
                this.$router.push(`/tehui/`);
            }
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/common/top-menu.vue